import React from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { 
  AppBar, 
  Box, 
  CssBaseline, 
  Drawer,
  Divider,
  IconButton, 
  List, 
  ListItem, 
  ListItemButton, 
  ListItemIcon, 
  ListItemText, 
  Toolbar, 
  Typography,
  Button,
  Avatar,
  Menu,
  MenuItem,
  Chip
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import PersonIcon from '@mui/icons-material/Person';
import CallIcon from '@mui/icons-material/Call';
import LanguageIcon from '@mui/icons-material/Language';
import LogoutIcon from '@mui/icons-material/Logout';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import SettingsIcon from '@mui/icons-material/Settings';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PaymentIcon from '@mui/icons-material/Payment'; // For withdrawal icons

const drawerWidth = 240;

function Layout() {
  const { currentUser: user, logout } = useAuth();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const getRoleColor = (role) => {
    switch (role) {
      case 'admin':
        return 'error'; // red for admin
      case 'merchant':
        return 'warning'; // orange for merchant
      default:
        return 'default';
    }
  };

  const getRoleDisplayText = (role) => {
    switch (role) {
      case 'admin':
        return 'Admin';
      case 'merchant':
        return 'Merchant';
      default:
        return role;
    }
  };

  const drawer = (
    <>
      <Toolbar>
        <Typography variant="h6" noWrap component="div">
          Flash Admin
        </Typography>
      </Toolbar>
      <Divider />
      <List>
        <ListItem disablePadding component={Link} to="/admin/dashboard" style={{ textDecoration: 'none', color: 'inherit' }}>
          <ListItemButton>
            <ListItemIcon>
              <DashboardIcon />
            </ListItemIcon>
            <ListItemText primary="Dashboard" />
          </ListItemButton>
        </ListItem>
        {user?.isAdmin === true && (
          <ListItem disablePadding component={Link} to="/admin/users" style={{ textDecoration: 'none', color: 'inherit' }}>
            <ListItemButton>
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary="Admin Users" />
            </ListItemButton>
          </ListItem>
        )}

        <ListItem disablePadding component={Link} to="/admin/app-users" style={{ textDecoration: 'none', color: 'inherit' }}>
          <ListItemButton>
            <ListItemIcon>
              <PersonIcon />
            </ListItemIcon>
            <ListItemText primary="App Users" />
          </ListItemButton>
        </ListItem>

        <ListItem disablePadding component={Link} to="/admin/call-logs" style={{ textDecoration: 'none', color: 'inherit' }}>
          <ListItemButton>
            <ListItemIcon>
              <CallIcon />
            </ListItemIcon>
            <ListItemText primary="Call Logs" />
          </ListItemButton>
        </ListItem>
        {user?.isAdmin === true && (
          <ListItem disablePadding component={Link} to="/admin/historical-call-logs" style={{ textDecoration: 'none', color: 'inherit' }}>
            <ListItemButton>
              <ListItemIcon>
                <CallIcon />
              </ListItemIcon>
              <ListItemText primary="Historical Calls" />
            </ListItemButton>
          </ListItem>
        )}
        <ListItem disablePadding component={Link} to="/admin/call-rates" style={{ textDecoration: 'none', color: 'inherit' }}>
          <ListItemButton>
            <ListItemIcon>
              <AttachMoneyIcon />
            </ListItemIcon>
            <ListItemText primary="Call Rates" />
          </ListItemButton>
        </ListItem>

        {/* Add Deposit Management menu items - Allow both admin and merchant access */}
        {(user?.isAdmin === true || user?.role === 'merchant') && (
          <>
            <ListItem disablePadding component={Link} to="/admin/deposit-admin" style={{ textDecoration: 'none', color: 'inherit' }}>
              <ListItemButton>
                <ListItemIcon>
                  <AccountBalanceIcon />
                </ListItemIcon>
                <ListItemText primary="Deposit Overview" />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding component={Link} to="/admin/transaction-history" style={{ textDecoration: 'none', color: 'inherit' }}>
              <ListItemButton>
                <ListItemIcon>
                  <AttachMoneyIcon />
                </ListItemIcon>
                <ListItemText primary="Transaction History" />
              </ListItemButton>
            </ListItem>
            {/* New Menu Item for Deposit Orders CRUD */}
            <ListItem disablePadding component={Link} to="/admin/deposit-orders" style={{ textDecoration: 'none', color: 'inherit' }}>
              <ListItemButton>
                <ListItemIcon>
                  <ShoppingCartIcon /> 
                </ListItemIcon>
                <ListItemText primary="Deposit Orders" />
              </ListItemButton>
            </ListItem>
            {/* Withdrawal Menu Items */}
            {/* withdrawal-request menu ကို ယာယီရပ်ဆိုင်းထားခြင်း */}
            {/* 
            <ListItem disablePadding component={Link} to="/admin/withdrawal-request" style={{ textDecoration: 'none', color: 'inherit' }}>
              <ListItemButton>
                <ListItemIcon>
                  <PaymentIcon />
                </ListItemIcon>
                <ListItemText primary="Request Withdrawal" />
              </ListItemButton>
            </ListItem>
            */}
            <ListItem disablePadding component={Link} to="/admin/withdrawal-admin" style={{ textDecoration: 'none', color: 'inherit' }}>
              <ListItemButton>
                <ListItemIcon>
                  <PaymentIcon />
                </ListItemIcon>
                <ListItemText primary="Withdrawal Management" />
              </ListItemButton>
            </ListItem>
          </>
        )}
        {/* SIP Domains menu ကို ယာယီ hide လုပ်ခြင်း */}
        {/* 
        {user?.isAdmin === true && (
          <ListItem disablePadding component={Link} to="/admin/sip-domains" style={{ textDecoration: 'none', color: 'inherit' }}>
            <ListItemButton>
              <ListItemIcon>
                <LanguageIcon />
              </ListItemIcon>
              <ListItemText primary="SIP Domains" />
            </ListItemButton>
          </ListItem>
        )}
        */}
        {user?.isAdmin === true && (
          <ListItem disablePadding component={Link} to="/admin/settings" style={{ textDecoration: 'none', color: 'inherit' }}>
            <ListItemButton>
              <ListItemIcon>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText primary="Settings" />
            </ListItemButton>
          </ListItem>
        )}
        {user?.isAdmin === true && (
          <ListItem disablePadding component={Link} to="/admin/merchants" style={{ textDecoration: 'none', color: 'inherit' }}>
            <ListItemButton>
              <ListItemIcon>
                <AccountBalanceIcon />
              </ListItemIcon>
              <ListItemText primary="Merchants" />
            </ListItemButton>
          </ListItem>
        )}
      </List>
      <Divider />
      <List>
      {/* {user?.isAdmin === true && (
        <ListItem disablePadding component={Link} to="/call" style={{ textDecoration: 'none', color: 'inherit' }}>
          <ListItemButton>
            <ListItemIcon>
              <CallIcon />
            </ListItemIcon>
            <ListItemText primary="ဖုန်းခေါ်ရန်" />
          </ListItemButton>
        </ListItem>
      )} */}
        <ListItem disablePadding>
          <ListItemButton onClick={handleLogout}>
            <ListItemIcon>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText primary="Logout" />
          </ListItemButton>
        </ListItem>
      </List>
    </>
  );

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
            Flash Administration
          </Typography>
          <div>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Chip 
                label={getRoleDisplayText(user?.role)} 
                color={getRoleColor(user?.role)}
                size="small"
                sx={{ color: 'white', fontWeight: 'bold' }}
              />
              <Button 
                color="inherit" 
                startIcon={
                  <Avatar 
                    sx={{ 
                      width: 32, 
                      height: 32, 
                      bgcolor: 'primary.dark',
                      fontSize: '1rem'
                    }}
                  >
                    {user?.username?.charAt(0).toUpperCase() || 'U'}
                  </Avatar>
                } 
                onClick={handleMenuOpen}
              >
                {user?.username || 'User'}
              </Button>
            </Box>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              <MenuItem onClick={() => { handleMenuClose(); navigate('/admin/profile'); }}>
                <AccountCircleIcon fontSize="small" sx={{ mr: 1 }} />
                Profile
              </MenuItem>
              <MenuItem onClick={handleLogout}>
                <LogoutIcon fontSize="small" sx={{ mr: 1 }} />
                Logout
              </MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
      >
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{ flexGrow: 1, p: 3, width: { sm: `calc(100% - ${drawerWidth}px)` } }}
      >
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
}

export default Layout;
